import { z } from 'zod';

export const forgotSchema = z.object({
  email: z.email('Enter a valid email address.'),
});

export const resetSchema = z
  .object({
    // Digits-only, to match the server's `digits:6` — a six-character non-numeric code
    // would otherwise pass here and come back as a 422.
    otp: z
      .string()
      .trim()
      .regex(/^\d{6}$/, 'Enter the 6-digit code.'),
    password: z.string().min(8, 'Password must contain at least 8 characters.'),
    passwordConfirm: z.string(),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    path: ['passwordConfirm'],
    message: 'Passwords do not match.',
  });
